import { render, staticRenderFns } from "./LxPaginationLight.vue?vue&type=template&id=4ec6f335&scoped=true"
import script from "./LxPaginationLight.vue?vue&type=script&lang=js"
export * from "./LxPaginationLight.vue?vue&type=script&lang=js"
import style0 from "./LxPaginationLight.vue?vue&type=style&index=0&id=4ec6f335&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec6f335",
  null
  
)

export default component.exports